<template>

    <label v-bind:class="cssLabel">
        <slot name="label"></slot>
    </label>
    <CustomButton :title="selectedText" class="text-nowrap text-left whitespace-nowrap" predefinedStyle="inputTyp"
        @button:click="open = !open">
        <template #label>
            {{ truncatedText }}
        </template>
    </CustomButton>
    <dropdown-menu v-show="open" @menu:select="selectOption($event)" class="absolute" :menuOptions="possibleSelections"
        :data="{}">

    </dropdown-menu>

</template>
<script>
import _ from 'lodash';
export default {
    props: {
        limit: {
            type: Number,
            default: 20,
        },
        value: {
        },
        columndata: {

        },
        predefinedStyle: {
            type : String,
            default : undefined,
        }
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        selectOption(event) {
            var index = this.value.findIndex(item => item == event.value);
            var tmp = this.value;
            if (index > -1) {
                tmp.splice(index, 1);
            } else {
                tmp.push(event.value);
            }
            this.$emit("update:value", tmp);
        }
    },
    computed: {
        selectedText() {
            var tmp = "";
            for (let i in this.value) {
                var index = this.possibleSelections.findIndex(item => item.value == this.value[i]);
                if (index > -1) {
                    if (i != 0) {
                        tmp += ", ";
                    }
                    tmp += this.possibleSelections[index].text;
                }
            }
            if (tmp == "") {
                return "None";
            }
            return tmp;
        },
        truncatedText() {
            return _.truncate(this.selectedText, { length: this.limit, omission: " ..." });
        },
        possibleSelections() {
            var tmp = [];
            if (this.companyTypes) {
                for (let i in this.companyTypes) {
                    tmp.push({
                            key: "select",
                            text: this.companyTypes[i].name,
                            value: this.companyTypes[i].id,
                            icon: (this.value.length > 0 && this.value.includes(this.companyTypes[i].id)) ? "far fa-check-square" : "far fa-square",
                        });
                }
            }
            return tmp;
        },
        companyTypes() {
            return this.$store.state.companies.companyTypes.list;
        },
        cssLabel: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle]["label"];
            }
            return this.predefinedStyles["default"]["label"];
        },
        cssInput: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle]["input"];
            }
            return this.predefinedStyles["default"]["input"];
        },
        predefinedStyles() {
            return {
                default: {
                    label: "text-base text-stone-900 dark:text-slate-100 font-bold mb-1",
                    input: "w-full text-base outline-none border-2 border-gray-200 dark:border-transparent dark:hover:border-slate-500 dark:focus-visible:border-slate-500 focus-visible:border-accent-color rounded-md py-1.5 px-3 dark:bg-gray-700"
                },
            };
        }
    }
};
</script>
<style scoped></style>
